'use strict';

function Notifications($timeout, pmtNotificationService, $i18next, pmtPlanHatService) {
	let $ctrl = this;
	$ctrl.notifications = [];

	$ctrl.shouldHaveShadow = index => {
		const isSecondLast = index === $ctrl.notifications.length - 2;
		const isLast = index === $ctrl.notifications.length - 1;

		return isSecondLast ? $ctrl.notifications[index + 1].exit : isLast;
	};

	$ctrl.dismiss = function (notification) {
		notification.exit = true;
		pmtPlanHatService.track('listingsNotificationClickedOnDismiss');
		$timeout(function () {
			pmtNotificationService.dismissNotification(notification).catch(function (error) {
				console.log('error', error);
			});
		}, 400);
	};

	$ctrl.dismissAndNavigate = function (evt, notification) {
		evt.preventDefault();
		evt.stopPropagation();

		let url = notification.link.url;

		$ctrl.notifications = $ctrl.notifications.map(function (n) {
			n.exit = true;
			return n;
		});
		pmtPlanHatService.track('listingsNotificationClickedOnDetails');
		pmtNotificationService.dismissAllNotifications().catch(function (error) {
			console.log('error', error);
		});

		window.open(url, '_blank');
	};

	$ctrl.getMessage = function (message) {
		if (message.includes('PIN_DROP_REQUIRED')) {
			const pinDropRequiredInfo = $i18next.t('general.pin_drop_required_info');
			return `${message}. ${pinDropRequiredInfo}`;
		}
		return message;
	};

	$ctrl.getTranslatedNavigateButtonText = function (text) {
		if (text === 'Show conflict') {
			return $i18next.t('general.show_conflict');
		}
		return $i18next.t('general.details');
	};

	pmtNotificationService.subscribeToNotifications(function (notifications) {
		$ctrl.notifications = notifications.sort(function (a, b) {
			return a.updatedAt > b.updatedAt ? 1 : -1;
		});

		if (notifications[0] && /success/.test(notifications[0].type)) {
			$timeout(function () {
				$ctrl.dismiss(notifications[0]);
			}, 3000);
		}
		if (
			notifications[0] &&
			notifications[0].message &&
			notifications[0].message.includes('Error: key www.bingplaces.com:443:::::::0')
		) {
			notifications[0].message = notifications[0].message = 'An unexpected error occurred';
		}
	});
}

Notifications.$inject = ['$timeout', 'pmtNotificationService', '$i18next', 'pmtPlanHatService'];

angular
	.module('PinMeTo.notifications')

	.component('pmtNotifications', {
		templateUrl: 'pmtShared/notifications/pmtNotifications.html',
		controller: Notifications
	});
